/**
 * Axios Configuration
 */

import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://a2amyworkai-server.appsokay.net/api/v1',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - return data; surface backend message on failures
axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;
    const apiMessage = error.response?.data?.message;
    console.error('[API Error]', status, url, apiMessage || error.message);
    if (apiMessage) {
      error.message = apiMessage;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

